<template>
    <div id="app" :style="paddingStyle">
        <div v-if="isPageLoading">
            <loadingScreen :shopData="shopData" />
        </div>
        <div v-else>
            <shopMenu
                ref=""
                @fetchListings="openCartSidebar"
                @searchListings="openCartSidebar"
                @openCartSidebar="openCartSidebar"
                @showCategoriesDrawer="openCategoriesDrawer"
                @openContactPopup="openContactPopup"
                :shopData="shopData"
                :listingsData="listingData"
                :feedbackStats="feedbackStatsData"
                :backgroundColor="menuBackground"
                :customWidth="menuWidth"
                :currentRouteName="currentRouteName"
                v-if="currentRouteName != 'checkoutPage' && currentRouteName != 'catalogPage' && currentRouteName != 'listingPage' && currentRouteName != 'paymentPage'"
            />
            <catalogMenu
                ref="catalogMenuRef"
                @fetchListings="openCartSidebar"
                @searchListings="openCartSidebar"
                @openCartSidebar="openCartSidebar"
                @showShippingProfileDrawer="showShippingProfileDrawer"
                @searchProduct="searchProduct"
                @openContactPopup="openContactPopup"
                :shopData="shopData"
                :listingsData="listingData"
                :feedbackStats="feedbackStatsData"
                :backgroundColor="menuBackground"
                :customWidth="menuWidth"
                :screenWidth="screenWidth"
                :style="{
                    paddingLeft: (currentRouteName === 'catalogPage' && screenWidth > 1571) ? '75px' : '0px'
                }"
                v-if="currentRouteName == 'catalogPage' || currentRouteName == 'listingPage'"
            />
            <div class="container">
                <div class="leftSideRail">
                    <categoriesMenu :shopData="shopData" :allCategories="allCategories" class="categoriesMenu" @categoryChange="categoryChange" @openContactPopup="openContactPopup" ref="categoriesMenu" 
                    v-if="
                        currentRouteName === 'catalogPage' && screenWidth >= 1570
                    "
                    />
                </div>
        
                <!-- <notifications group="foo" animation-type="velocity" position='top center' /> -->
                <div class="mainBody" :style="computedStyle">
                    <router-view
                        @openCartSidebar="openCartSidebar"
                        @routeChange="routeChange"
                        @getShopListings="dataFetchListing"
                        @openContactPopup="openContactPopup"
                        @openCategoriesDrawer="openCategoriesDrawer"
                        @showShippingProfileDrawer="showShippingProfileDrawer"
                        @resetSearch="resetSearch"
                        @logout="logout"
                        @updateSortMethod="updateSortMethod"
                        :allCategories="allCategories"
                        :currentRouteName="currentRouteName"
                        :userGroups="userGroups"
                        :shopData="shopData"    
                        :idShop="idShop"    
                        :shopPageUrl="shopPageUrl"    
                        :feedbacksData="feedbacksData"    
                        :feedbackStatsData="feedbackStatsData"    
                        :listingData="listingData"    
                        :listingsDataRaw="listingsDataRaw"    
                        :cardLoadingTime="cardLoadingTime"    
                        :counter="counter"    
                        :shippingProfileData="shippingProfileData"
                        :cartContentChange="cartContentChange"   
                        :searchWord="searchWord"
                        :key="$route.params.lang"
                        :currentLang="currentLang"
                    />
                </div>
            </div>
            <footerSmall 
                ref="pageFooter"
                v-if=" shopData.legalEntity && currentRouteName != 'shopLanding'"
                @openCartSidebar="openCartSidebar"
                @showShippingProfileDrawer="showShippingProfileDrawer"
                @activateBackground='isNavigationsActive = true' 
                @deactivateBackground='isNavigationsActive = false' 
                :shopData="shopData" 
                :userGroups="userGroups" 
            />
    
            <footerMain 
                v-if="currentRouteName == 'shopLanding'"
                :currentRouteName="currentRouteName" 
                @openCartSidebar="openCartSidebar"
            />
            <cartSidebar 
                ref="cartSidebarRef"
                @routeChange="routeChange"
                @cartContentChange="cartContentChange ++"
                @openCatalog="$router.push({name: 'catalogPage'}); $refs.cartSidebarRef.visibleRight = false"
                :currentRouteName="currentRouteName"
                @sidebarVisibility="isSidebarVisible = false" 
                :idShop="idShop" 
                :currentLang="currentLang"
                :shopData="shopData"  
            />
            <shippingProfileSidebar 
                ref="shippingProfileSidebarRef"
                @shippingProfileSidebar="isShippingProfileSidebarVisible = false" 
                :idShop="idShop" 
                :shopData="shopData"
                :shippingProfileData="shippingProfileData"
                :currentLang="currentLang"
            />
    
    
            <div :class="{ 'darkBackgroundHidden': !isNavigationsActive, 'darkBackground': isNavigationsActive  }" @click="deactivateFooterNav"></div>
    
            <Toast />
            <ConfirmDialog></ConfirmDialog>
            <!-- <demoMenu v-if="isProduction" /> -->
            <contactPopup :currentLang="currentLang" ref="contactPopupRef" />
            <categoriesDrawer ref="categoriesDrawerRef" :categories="allCategories" :shopData="shopData" @categoryChange="categoryChange" @openContactPopup="openContactPopup" />
        </div>
    </div>
</template>

<script>
import logoutFetch from '@/apiFetches(old)/logoutFetch'
import roundtrip from '@/apiFetches(old)/roundtripRegulator'
import userShop from '@/apiFetches(old)/userShop'
import shippingProfileFetch from '@/apiFetches(old)/shippingProfile'
import core from '@/api/index'

import loadingScreen from "@/components/loadingScreen.vue"
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
// import demoMenu from './components/menus/demoMenu.vue'
import shopMenu from '@/components/menus/shopMenu.vue';
import catalogMenu from '@/components/menus/catalogMenuSmall.vue';
import categoriesMenu from '@/components/menus/categoriesMenu.vue'
import footerSmall from '@kristjan87/storium-shop-library/src/components/universal/footer/footer.vue'
import footerMain from '@/components/menus/footer/footer.vue';
import contactPopup from '@/components/popup/contact.vue';

import cartSidebar from '@kristjan87/storium-shop-library/src/components/main/checkout/cart/cartSidebar.vue';
import shippingProfileSidebar from '@kristjan87/storium-shop-library/src/components/main/shop/shipping/drawer/shippingProfile.vue';
import categoriesDrawer from './components/shopLanding/categoriesDrawer.vue'

export default {
    name: 'App',
    components: {
        shopMenu,
        // demoMenu,
        categoriesMenu,
        contactPopup,
        footerSmall,
        cartSidebar,
        ConfirmDialog,
        Toast,
        catalogMenu,
        loadingScreen,
        footerMain,
        categoriesDrawer,
        shippingProfileSidebar
    },
    watch: {
        $route() {
            this.dataFetchListing(false, false, false, null); 
            this.searchWord = ''
            this.activeIdListingTag = null
        },
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        },
        currentLang() {
            return this.$route.params.locale || 'et';
        },
        paddingStyle() {
            const { innerWidth } = window;
            let paddingTop;

            if (innerWidth < 1320) {
                if (this.currentRouteName === 'catalogPage' || this.currentRouteName === 'listingPage') {
                paddingTop = '75px';
                } else {
                paddingTop = '45px';
                }
            } else {
                // Set padding for widths >= 1320. 
                // Adjust this if you need a different default for larger widths.
                paddingTop = '75px';
            }

            return {
                paddingTop,
                paddingBottom: this.isProduction ? '0px' : '0px'
            };
        },
        computedStyle() {
            const width = this.currentRouteName === 'catalogPage' || this.currentRouteName === 'listingPage' || this.currentRouteName === 'shopLanding' || this.currentRouteName === 'contactPage'
                ? '100%'
                : '1300px';
                
            return {
                width
            };
        },
        menuWidth() {
            let width = this.currentRouteName === 'catalogPage'
                ? '1300px'
                : this.currentRouteName === 'listingPage'
                ? '1300px'
                : this.currentRouteName === 'shopLanding'
                ? '1300px'
                : '1300px';

            // Override if screen width < 1340px
            if (this.screenWidth < 1730 && this.currentRouteName === 'catalogPage') {
                width = '100%';
            }
            if (this.screenWidth < 1350) {
                width = '100%';
            }

            return { width };
        },
        menuBackground() {
            return this.currentRouteName === 'shopLanding' ? '#EFF1F3' : '#FFFFF'
            
        },

        isProduction() {
            return process.env.NODE_ENV === 'production';
        }

    },
    metaInfo() {
        return {
            title: this.shopData.shopName
        }
    },
    data() {
        return {
            userGroups: [],
            
            idShop: 41,
            shopData: [],
            shopPageUrl: false,

            feedbacksData: null,
            feedbackStatsData: null,

            listingData: [],
            listingsDataRaw: [],
            cardLoadingTime: 1000,
            counter: 0,

            shippingProfileData: null,

            isNavigationsActive: false,
            isSidebarVisible: false,
            isShippingProfileSidebarVisible: false,
            allCategories: null,
            cartContentChange: 0,
            searchWord: '',
            activeIdListingTag: null,
            sort: null,
            isPageLoading: true,

            screenWidth: window.innerWidth
        }
    },
    methods: {
        openCategoriesDrawer() {
            this.$refs.categoriesDrawerRef.visibleRight = true
        },
        openContactPopup() {
            this.$refs.contactPopupRef.visible = true
        },
        showShippingProfileDrawer() {
            this.$refs.shippingProfileSidebarRef.visibleRight = true
        },

        openCartSidebar() {
            this.$refs.cartSidebarRef.fetchOrders()
            this.$refs.cartSidebarRef.visibleRight = true

            this.isSidebarVisible = true
        },

        categoryChange(idListingTag) {
            this.dataFetchListing(false, false, false, idListingTag)
            if(this.$refs.categoriesMenu) {
                this.$refs.categoriesMenu.activeCategory = idListingTag
            }
        },

        routeChange(pageName, id) {
            if(pageName == 'checkoutPage') {
                this.$router.push({ name: pageName, params: { idOrder: id } })
            }
            if(pageName == 'catalogPage') {
                this.$router.push({ name: pageName, params: { idShop: id } })
            }
        },

        searchProduct(searchWord) {
            if(this.currentRouteName != 'catalogPage') {
                this.$router.push({name: 'catalogPage'})
            }
            setTimeout(() => {
                this.searchWord = searchWord
                this.dataFetchListing(false,false,false,this.activeIdListingTag)
            }, 1);
        },

        resetSearch() {
            if(this.$refs.categoriesMenu) {
                this.$refs.categoriesMenu.activeCategory = null
            }
            this.$refs.catalogMenuRef.searchWordString = null
            this.searchWord = ''
            this.activeIdListingTag = null
            this.dataFetchListing()
        },

        deactivateFooterNav() {
            this.isNavigationsActive = false
            this.$refs.pageFooter.isNavigationsActive = false
        },

        updateSortMethod(method) {
            this.sort = method
            this.dataFetchListing()
        },

        fetchShopData: async function() {
            if(this.shopPageUrl) {
                userShop(this.shopPageUrl, true)
                .then((res) => {
                    if(res.data === null) {
                        this.$router.push('/puudub/404')
                    }
                    if(res.message == 'Object does not exist that the access is requested for.' || res.message == 'Something went wrong, please try again or contact support.') {
                        this.$router.push({
                            name: 'resource404',
                            params: {
                                resource: 'pood'
                            }
                        })
                    }
                    this.idShop = res.data.shop.idShop
                    this.shopData = res.data.shop

                    // this.fetchListings()
                    this.fetchFeedback(this.idShop)
                    this.fetchShippingProfile()
                })
            } else {
                userShop(this.idShop)
                .then((res) => {
                    if(res.message == 'Object does not exist that the access is requested for.' || res.message == 'Something went wrong, please try again or contact support.') {
                        this.$router.push({
                            name: 'resource404',
                            params: {
                                resource: 'pood'
                            }
                        })
                    }
                    this.shopData = res.data.shop

                    // if(res.data.shop.shopPageUrl) {
                    //     history.replaceState(
                    //         {}, null, 
                    //         '/'+res.data.shop.shopPageUrl
                    //     )
                    // } else {
                    //     history.replaceState(
                    //         {}, null, 
                    //         '/pood/'+res.data.shop.idShop
                    //     )
                    // }
                    // this.fetchListings()
                    this.fetchFeedback(this.idShop)
                    this.fetchShippingProfile()
                })
            }
        },

        fetchFeedback: async function(idShop) {
            core.feedbackApi.getPublicShopFeedbacks({
                pathParam: idShop,
                queryParams: { 
                    limiter: 100,
                    offset: 0
                }
            })
            .then((res) => {
                if(res.data.feedbacks) {
                    this.feedbacksData = res.data.feedbacks.received
                    this.feedbacksData.reverse()
                } else {
                    this.feedbacksData = null
                }
                this.fetchFeedbackStats(idShop)
            })
        },

        fetchFeedbackStats(idShop) {
            core.feedbackApi.getPublicShopFeedbacks({
                pathParam: idShop,
                queryParams: {
                    metadata: true
                }
            })
            .then(res => {
                if(res.data.feedbacks.metadata) {
                    this.feedbackStatsData = res.data.feedbacks.metadata
                }
            })
        },

        fetchShippingProfile: async function() {
            shippingProfileFetch(this.idShop)
            .then((res) => {
                if(res.data != null) {
                    this.shippingProfileData = res.data.shippingProfile
                    setTimeout(() => {
                        this.isLoading = false
                    }, 100)
                } else {
                    this.shippingProfileData = null
                    setTimeout(() => {
                        this.isLoading = false
                    }, 100)
                }
            })
        },

        dataFetchListing: async function(pageChange, reset, resetFilters, idListingTag) {
            if(reset == true) {
                this.currentPage = 1
                this.counter = 0
                this.noMoreListings = false
                setTimeout(() => {
                    window.scrollTo({ top: 0 });
                }, 1)
            }
            if(resetFilters) {
                this.$refs.categoryFiltersComp.availableFilters = []
                this.$refs.categoryFiltersComp.getFilterElements()
            }

            this.counter = this.counter - 15
            this.loadedImgCount = 0

            if(pageChange === false) {
                this.currentPage ++
            }
            if(pageChange === true) {
                this.currentPage --
            }

            let listingsPerPage = this.listingsPerPage
            var offset = (this.currentPage * listingsPerPage) - listingsPerPage

            localStorage.setItem('categoryOffset', this.currentPage)

            var sortMethod = ''
            if(this.sort) {
                sortMethod = this.sort
            } else {
                sortMethod = 'ASC'
            }

            this.filterParams = []
            let shippingOptions = []
            let freeDeliveryThreshold = null
            let minOptionAmount = null

            if(this.$refs.categoryFiltersComp) {
                let activeFilters = this.$refs.categoryFiltersComp.availableFilters
                
                for(const element of activeFilters) {
                    for(const subElement of element.params) {
                        if(subElement.isTagged) {
                            this.filterParams.push(subElement.idFilterParam)
                        }
                    }
                }

                shippingOptions = this.$refs.categoryFiltersComp.shippingOptions
                freeDeliveryThreshold = this.$refs.categoryFiltersComp.freeDeliveryThreshold
                minOptionAmount = this.$refs.categoryFiltersComp.minOptionAmount

                if(freeDeliveryThreshold == 'kõik') {
                    freeDeliveryThreshold = null
                }
                if(minOptionAmount == 'kõik') {
                    minOptionAmount = null
                }
            }

            this.activeFiltersCount = shippingOptions.length + this.filterParams.length
            if(freeDeliveryThreshold != null) {
                this.activeFiltersCount ++
            }
            if(minOptionAmount != null) {
                this.activeFiltersCount ++
            }

            // let id
            // if(this.idListingTagSearch) {
            //     id = this.idListingTagSearch
            // } else {
            //     id = this.idListingTag
            // }

            // let word
            // if(this.searchWord) {
            //     this.searchActive = true
            //     this.searchWordActive = this.searchWord
            //     word = this.searchWord
            // } else {
            //     this.searchActive = false
            //     this.searchWordActive = null
            //     word = ''
            // }


            this.activeIdListingTag = idListingTag
            this.idsOfListings = []
            if(isNaN(this.idListingTag)) {
            this.idListingTag = 0
            }


            core.listingApi.getListingsWithOffset({
                queryParams: {
                    offset: offset,
                    limiter: 100,
                    searchString: this.searchWord,
                    idListingTag: idListingTag,
                    filterParams: this.filterParams,
                    shippingOptions: shippingOptions,
                    freeDeliveryThreshold: freeDeliveryThreshold,
                    minOptionAmount: minOptionAmount,
                    orderPriceAs: sortMethod,
                    idShop: this.idShop
                }
            })
            .then((res) => {
                if(res.data.listings == null) {
                    this.noMoreListings = true
                    this.isLoading = false
                    this.listingData = []
                } else {
                    if(reset) {
                        this.listingData = []
                    }
                    this.listingData = []
                    for(const element of res.data.listings) {
                        this.listingData.push(element)
                    }
                    this.listingData = this.rearrangeArray(this.idsOfListings, this.listingData)
                    this.noMoreListings = false
                    this.noMoreListingsMessage = false
                    setTimeout(() => {
                        this.isLoading = false
                    }, 500);

                    if(res.data.listings.length < this.listingsPerPage) {
                        this.noMoreListings = true
                    }
                }
            })
            .catch((err) => {
                this.catchError = err
            })  
        },

        fetchListingsRaw() {
            fetch(this.$fetchIp+'/v2/listing/shop/public/'+this.idShop+'?offset=0&limiter=100', {
                method: 'GET',
                headers: {
                    'Content-type':'application/json'
                },
                credentials: 'include',
            })
            .then((res) => res.json()) 
            .then((res) => {
                if(res.data.listings != null) {
                    this.listingsDataRaw = res.data.listings
                } else {
                    this.listingsDataRaw = []
                }
            })
        },

        rearrangeArray(array1, array2) {
            if(isNaN(this.idListingTag)) {
                const result = [];

                for (let i = 0; i < array1.length; i++) {
                    const object = array2.find(obj => obj.idListing === array1[i]);
                    if (!object) continue;
                    result.push(object);
                    const index = array2.indexOf(object);
                    array2.splice(index, 1);
                }

                return result;
            } else {
                return array2
            }
        },

        getAllCategories() {
            core.tagApi.listingTagApi.getListingTagTree({
                queryParams: { 
                    idShop: this.idShop
                }
            })
            .then((res) => {
                this.allCategories = res.data.categoriesTree
            })
            .catch(error => {
                console.error("Failed to fetch categories:", error);
            });
        },

        handleResize() {
            this.screenWidth = window.innerWidth;
        },

        logout() {
            logoutFetch()
            setTimeout(() => {
                this.roundtrip()
            },1)
        },

        roundtrip: async function() {
            roundtrip(this.$options.name)
            .then((res) => {
                this.userGroups = res.userGroups
            })
        },
    },

    mounted() {
        // Add an event listener when the component is mounted
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        // Clean up the event listener to prevent memory leaks
        window.removeEventListener('resize', this.handleResize);
    },

    created() {
        this.roundtrip()
        this.fetchShopData()
        this.dataFetchListing()
        this.fetchListingsRaw()
        this.getAllCategories()

        setTimeout(() => {
            this.isPageLoading = false
        }, 2400)
    },

}
</script>

<style>
/* Site title font */
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300..700&display=swap');
/* Site paragraph font */
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&family=Space+Grotesk:wght@300..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Manrope:wght@200..800&family=Space+Grotesk:wght@300..700&display=swap');
/* wtf is this */
@import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lora&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Palanquin+Dark&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Baloo+2:wght@500;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Raleway&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Muli:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Krub&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lora:ital,wght@1,400;1,700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;700&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap');
@font-face {
font-family: 'Satoshi-Regular';
src: url('./assets/webfonts/Satoshi-Regular.woff2') format('woff2'),
    url('./assets/webfonts/Satoshi-Regular.woff') format('woff'),
    url('./assets/webfonts/Satoshi-Regular.eot') format('truetype');
    font-weight: 400;
    font-display: swap;
    font-style: normal;
}
  
  
@font-face {
font-family: 'Satoshi-Medium';
src: url('./assets/webfonts/Satoshi-Medium.woff2') format('woff2'),
    url('./assets/webfonts/Satoshi-Medium.woff') format('woff'),
    url('./assets/webfonts/Satoshi-Medium.eot') format('truetype');
    font-weight: 500;
    font-display: swap;
    font-style: normal;
}
  
  
@font-face {
font-family: 'Satoshi-Bold';
src: url('./assets/webfonts/Satoshi-Bold.woff2') format('woff2'),
    url('./assets/webfonts/Satoshi-Bold.woff') format('woff'),
    url('./assets/webfonts/Satoshi-Bold.eot') format('truetype');
    font-weight: 700;
    font-display: swap;
    font-style: normal;
}
.darkBackground {
    position: fixed;
    z-index: 1051;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    transition: .5s;
}
.darkBackgroundHidden {
    position: fixed;
    z-index: -1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0);
    transition: .5s;
}
#app {
    background: rgb(247, 251, 253);
    min-height: 100vh;
    height: 100%;
    overflow-x: hidden;
    /* padding-bottom: 28px; */
    /* padding-top: 128px; */
}
.container {
    display: flex;
}
.mainBody {
    margin: 0 auto;
}

a {
    text-decoration: none;
    color: rgb(95, 94, 94);
}
body {
    overflow-x: hidden;
    margin: 0;
    padding: 0;
    font-family: "Manrope", sans-serif;
    font-weight: 400;
    /* min-height: 95vh; */
}
/* p {
    font-family: "Manrope", sans-serif;
} */

h1 {
    font-family: "Space Grotesk", sans-serif;
    color: rgb(68, 68, 68);
    font-size: 2.7rem; 
}

h2 {
    font-family: 'Ubuntu', sans-serif;
    color: rgb(48, 48, 48);
    font-size: 1.7rem;
    font-weight: 400;
}

/* FAT TITLE TEXT */
h5 {
    font-family: 'Palanquin Dark', sans-serif
}
textarea, input {
    font-family: 'Open Sans', sans-serif;
}

/* ////////// BUTTONS \\\\\\\\\\ */
    button {
        font-family: 'Lato', sans-serif;
        font-weight: 400;
    }

/* ////////// NUMBERS \\\\\\\\\\ */
    /* PRICE OF LISTINGS */
    .listingPrice {
        font-family: 'Noto Sans', sans-serif;
    }
    /* STATISTICS NUMBERS */
  
  
/* ////////// STATUS BOXES(LABELS) \\\\\\\\\\ */
    /*DASHDEALS SINGLE DEAL STATUS */
    .dealStatus p {
        font-family: 'DM Sans', sans-serif;
    }
    /* DASHBOARD MAIN PAGE */ 
    .singleOrderStatus p {
        font-family: 'DM Sans', sans-serif;
    }
    /* SHOP PRODUCTS STATUS */
    .statusContainer p {
        font-family: 'DM Sans', sans-serif;
    }

/* ////////// USER INPUT TEXT \\\\\\\\\\ */
    /* DESCRIPTION TEXTS */
    .descriptionText {
        font-family: 'Jaldi', sans-serif;
    } 
    /* SHOP NAME */
    .userSlogan h2, .userSlogan p {
        font-family: 'Lora', serif;
    }

/* ////////// 5 TYPES OF MENUS \\\\\\\\\\ */
    /* MEGAMENU DROPDOWN TITLES */
    nav.mega-menu .menutitles {
        font-family: 'Baloo 2', cursive;
    }
    nav.mega-menu ul.menu-area ul li a, nav.mega-menu ul.menu-area-2 ul li a {
        font-family: 'Open Sans', sans-serif;
    }

    /* MAIN TOP MENU */
    .profileBoxMenu {
        font-family: 'Baloo 2', cursive;
    }
    .profileButton a {
        font-family: 'Hind Siliguri', sans-serif;
    }
    .profileBoxBtn {
        font-family: 'Raleway', sans-serif;
    }
    .dashboard p {
        font-family: 'Raleway', sans-serif;
    }
    .dashboard a {
        font-family: 'Hind Siliguri', sans-serif;
    }

    /* SHOP MENU */
    .shopMenu p {
        font-family: 'Raleway', sans-serif;
    }
    .shopMenu ul>li {
        font-family: 'Baloo 2', cursive;
    }
    .contentMenu ul>li {
        font-family: 'Baloo 2', cursive;
    }

    /* DASHBOARD MENU BUTTONS */
    .dashboardMenu a {
        font-family: 'Muli', sans-serif;
    }

    /* LOGGED OUT MENU */
    nav.small-menu-nav ul li a {
        font-family: 'Krub', sans-serif;
    }

    /* PAGE FOOTER BUTTONS */ 
    .footer-section-items a {
        font-family: 'Muli', sans-serif;
    }

/* ////////// CUSTOM FONTS \\\\\\\\\\ */
    /* PAGE LOGO */ 
    .logo p {
        font-family: 'Cookie', 'Quicksand', sans-serif;
    }


@media(max-width: 890px) {
    .categoriesMenu {
        display: none;
    }
}

</style>
